import * as React from "react";
import { Applicant } from "../../../../../application/domain/application/application-entity";
import { ApplicantRow } from "./applicant-row";

const UnIncorporatedGroupKeys: {
  key: keyof Applicant;
  label: string;
}[] = [
  {
    key: "name",
    label: "団体名",
  },
  {
    key: "nameKana",
    label: "団体名（カナ）",
  },
  {
    key: "postalCode",
    label: "郵便番号",
  },
  {
    key: "address",
    label: "住所",
  },
  {
    key: "representativeName",
    label: "代表者名",
  },
  {
    key: "tel",
    label: "電話番号",
  },
  {
    key: "email",
    label: "メールアドレス",
  },
  {
    key: "contactPersonal",
    label: "担当者名",
  },
];

export const ApplicantInfoUnIncorporatedGroup: React.FC<{
  getApplicantValue: (key: keyof Applicant) => string | undefined;
}> = ({ getApplicantValue }) => {
  return (
    <>
      <ApplicantRow label="種別" value="団体" testid="type" />
      {UnIncorporatedGroupKeys.map((v) => (
        <ApplicantRow
          label={v.label}
          value={getApplicantValue(v.key)}
          testid={v.key}
          key={v.key}
        />
      ))}
    </>
  );
};
